import { EventOption } from '@frontend/sports/betting-offer/feature/model';
import { Odds } from '@frontend/sports/odds/feature';
import { createSelector } from '@ngrx/store';

import { betslipTypeStateSelector } from '../types/selectors';

export const betslipTeaserBetsStateSelector = createSelector(betslipTypeStateSelector, (state) => state.teaserBet);

export interface ISelectablePickState {
    isSelected: boolean;
}

export interface ITeaserBetPickState extends ISelectablePickState {
    id: string;
    selectedOption: EventOption | undefined;
    eventId: string | undefined;
    oldPoints: number;
    newPoints: number;
    isNonBalancedPick?: boolean;
    isLocked: boolean;
    order: number;
}

export interface ITeaserBetState {
    picks: { [pickId: string]: ITeaserBetPickState };
    selectedPoints: number;
    stake: number | null;
    placeBlocking: boolean;
    actualStake: string | null;
    teaserPrice: Odds | undefined;
    priceVersionId: number;
    rewardTokenId: string | null;
}

export const defaultTeaserBetState: ITeaserBetState = {
    picks: {},
    selectedPoints: 0,
    stake: 0,
    placeBlocking: false,
    actualStake: '0',
    teaserPrice: undefined,
    priceVersionId: 0,
    rewardTokenId: '',
};

export const defaultTeaserBetPickState: ITeaserBetPickState = {
    id: '',
    isSelected: true,
    isLocked: false,
    selectedOption: undefined,
    eventId: undefined,
    oldPoints: 0,
    newPoints: 0,
    order: 0,
};

export interface ITeaserBetSavedState {
    picks: { [pickId: string]: any };
    selectedPoints: number;
    stake: number | null;
    placeBlocking: boolean;
    actualStake: string | null;
    teaserPrice: Odds | undefined;
    priceVersionId: number;
    rewardTokenId: string | null;
}
